import { QButton } from '@qualio/ui-components';
import { TemplateDetail } from '../../../../types/templateDetail';
import React, { useState } from 'react';
import { TemplateExportModal } from '../TemplateExportModal';

export const EXPORT_BUTTON_LABEL = 'Export';

type ExportDocumentTemplateButtonProps = {
  template: TemplateDetail;
};

export const ExportDocumentTemplateButton: React.FC<ExportDocumentTemplateButtonProps> = ({ template }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <QButton variant="ghost" onClick={handleOpenModal} data-cy="doc-template-export-button">
        {EXPORT_BUTTON_LABEL}
      </QButton>
      <TemplateExportModal isOpen={isModalOpen} onClose={handleCloseModal} template={template} />
    </>
  );
};
